import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateTimeslotForm from "../../forms/CreateOrUpdateTimeslotForm";
import { TimeslotResponseDto } from "../../shared/dtos/timeslot/TimeslotResponseDto";

interface UpdateTimeslotModalProps {
  open: boolean;
  onClose: () => void;
  timeslot: TimeslotResponseDto | null;
  userInfo?: any;
  loading: boolean;
  error: string | null;
}

const UpdateTimeslotModal: React.FC<UpdateTimeslotModalProps> = ({
  open,
  onClose,
  timeslot,
  userInfo,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Edit Timeslot"
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateTimeslotForm
      isEditing={true}
      timeslot={timeslot}
      userInfo={userInfo}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateTimeslotModal;
